import React from 'react';
import { Link } from 'react-router-dom';
import { PRODUCT_IMAGES } from '../data/mock';
import { useProducts } from '../hooks/useProducts';
import ProductCard from '../components/site/ProductCard';

export function GenderPage({ gender }) {
  const { products } = useProducts();
  const items = products.filter((p) => p.gender === gender);
  const isMen = gender === 'men';
  return (
    <div className="fade-in">
      <section className="relative overflow-hidden">
        <div className="aspect-[21/9] max-h-[70vh] w-full overflow-hidden">
          <img src={isMen ? PRODUCT_IMAGES.heroMen : PRODUCT_IMAGES.heroWomen} alt={gender} className="h-full w-full object-cover object-[center_15%]" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-espresso/80 via-espresso/40 to-transparent" />
        <div className="absolute bottom-0 left-0 w-full p-8 text-ivory md:p-16">
          <p className="eyebrow text-gold">{isMen ? 'Men' : 'Women'}</p>
          <h1 className="mt-2 font-display text-5xl md:text-7xl">{isMen ? 'Elevate Your Everyday.' : 'Your Everyday, Elevated.'}</h1>
          <p className="mt-4 max-w-xl text-ivory/90">{isMen ? 'Skincare, grooming essentials, and timeless accessories designed for the modern man.' : 'Beauty essentials, nourishing skincare, self-care rituals, and elegant jewelry.'}</p>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <p className="eyebrow text-espresso/60">{isMen ? 'The Modern Man Edit' : 'The Everyday Elegance Edit'}</p>
        <h2 className="mt-2 font-display text-4xl md:text-5xl">{isMen ? 'Considered essentials.' : 'Softly beautiful.'}</h2>
        <div className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((p) => <ProductCard key={p.id} p={p} />)}
        </div>
        <div className="mt-12 text-center">
          <Link to={`/shop?gender=${gender}`} className="btn btn-dark">Shop all {isMen ? 'men' : 'women'}</Link>
        </div>
      </section>
    </div>
  );
}

export default function UnisexPage() {
  const { products } = useProducts();
  const items = products.slice(0, 8);
  return (
    <div className="fade-in">
      <section className="bg-espresso text-ivory">
        <div className="mx-auto max-w-7xl px-5 py-20 text-center lg:px-8">
          <p className="eyebrow text-gold">The Unisex Collection</p>
          <h1 className="mt-3 font-display text-5xl md:text-7xl">Made for Everyone.<br/><em className="text-gold not-italic">Styled by You.</em></h1>
          <p className="mx-auto mt-6 max-w-2xl text-ivory/80">Discover thoughtfully selected essentials that go beyond labels. Beauty, care, and style are for everyone.</p>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((p) => <ProductCard key={p.id} p={p} />)}
        </div>
      </section>
    </div>
  );
}
